module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAABM0lEQVR42mJ06fvqycDAMBeIJRnIA8+BOHl3Idd2EIeJQsMYoHrnwjhMFBqGbCjcQKoCmIHVQMwOxIxEYnaoHpwG9gDxLxIcAlI7CZ+BJUDMRoKBrECch02CBUq3QjHVwpAUcBCI7YGYE4i5gdgIiGehu5BYcAaI3dDC+zwQp5PrwkaoYalA/AaK07B52RZPErFF8y4IdACxMBS3Y4sUfOA/EvsTFnkhbAYeJsHbn6EpYhW0YDAk1YXI4BsQOwDxOSSx45SEYSeaYWSlQ+QwXIrEzoZ6PwubgYehGrHhI0jqnyCxm4GYB4gbKMkpstTOekFI7FqolxspMbAUiBWg7KlAzAelUQx8ToKBIkB8Clp0KUBTgTQQRyEbmALEL0gwVBSIJwLxfSD+B8QngfgDTBIgwACEGj2g01G0MAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/GovernmentInformation.png
// module id = 61Lq
// module chunks = 1